import React, { useEffect, useState } from "react";
import { FaPrint } from "react-icons/fa";

const ChalanStatus = ({ student, formatDate }) => {
  const [paymentStatus, setpaymentStatus] = useState("");
  const [reversedTransactions, setReversedTransactions] = useState([]);
    
  useEffect(() => {
    if (!student || !Array.isArray(student.transactions) || student.transactions.length === 0) {
      setpaymentStatus("Pending");
      setReversedTransactions([]);
    } else {
      const transactions = student.transactions;
      setpaymentStatus(transactions[transactions.length - 1].status);
      // Create a reversed copy of the transactions array
      setReversedTransactions([...transactions].reverse());
    }
  }, [student]);

  return (
    <div className="main-dashboard-card">
       <div className="main-dashboard-ticket-item">
         <div>
            <h2 className="main-dashboard-card-title">My Transactions</h2>
            {/* <p className="main-dashboard-card-subtitle">Admission Forms</p> */}
          </div>
         

          
          
        </div>
      <div className="main-dashboard-card-body">
       
        {student?.transactions && (
          <>
            {student.transactions?.length === 0 ? (
              <div className="main-dashboard-app-item">
                <div className="main-dashboard-app-info">
                  <div className="main-dashboard-app-details">
                    <h4 className="main-dashboard-app-name">
                      No transactions yet
                    </h4>
                    <p className="main-dashboard-app-location">
                      Your transaction history will appear here after making
                      payments.
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="transaction-list">
                {reversedTransactions.map((transaction, index) => (
                  <div key={index} className="main-dashboard-app-item-2">
                    <div className="main-dashboard-app-info">
                      <div className="main-dashboard-app-details">
                        <span

                        style={{color:`${transaction.status === "success" ? "green" : "red"}`}}
                      className={`fee-details`}
                    >
                      {transaction.amount === "50.00" ? "Chalan Fee" : "Admission Fee"}
                    </span>
                        <h4 className="main-dashboard-app-name">
                          {`${transaction.txnid} - ₹${transaction.amount} `}
                        </h4>
                        <p className="main-dashboard-app-location">
                          {formatDate(transaction.created_at)}
                        </p>
                      </div>
                    </div>
                    <div>

<span
                      className={`main-dashboard-status-badge  ${
                        transaction.status === "success"
                          ? "main-dashboard-status-badge-resolved"
                          : " main-dashboard-status-badge-pending"
                      }`}
                    >
                      {transaction.status}
                   
                    </span>
                    

                     {
                      Number(transaction.amount) > 50 && (
                          <a
                    target="_blank"
              href={`https://gdclalitpur.ac.in/chalan-receipt/print-v1/${transaction.txnid}`}
                    style={{margin:"0px 5px",cursor:"pointer"}}
                      className={`main-dashboard-status-badge  ${
                        transaction.status === "success"
                          ? "main-dashboard-status-badge-resolved"
                          : " main-dashboard-status-badge-pending"
                      }`}
                    >
                      
                      <FaPrint/>
                     Scholarship Chalan
                    </a>
                      )
                    }

                    {
                      Number(transaction.amount) <= 5000 && (
                          <a
                    target="_blank"
              href={`https://gdclalitpur.ac.in/chalan-receipt/print/${transaction.txnid}`}
                    style={{margin:"0px 5px",cursor:"pointer"}}
                      className={`main-dashboard-status-badge  ${
                        transaction.status === "success"
                          ? "main-dashboard-status-badge-resolved"
                          : " main-dashboard-status-badge-pending"
                      }`}
                    >
                      
                      <FaPrint/>
                      Print
                    </a>
                      )
                    }

                  
                    </div>
                    

                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ChalanStatus;